import { colors } from 'Constants/Colors';

export const mainContainer = { width: '93%', margin: 'auto' };

export const containerButton = {
  width: '40%',
  height: '20%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export const loadingButtonStyle = {
  width: '50%',
  height: '30%',
  fontWeight: 'bold',
  background: colors.GREEN_LEAF,
  fontFamily: 'quicksand',
  color: colors.white,
};

export const loadingButtonDisabledStyle = {
  width: '50%',
  height: '30%',
  fontWeight: 'bold',
  background: colors.GRAY,
  fontFamily: 'quicksand',
  color: colors.white,
};

export const titleStyle = {
  fontSize: '2rem',
  marginTop: '0',
  fontFamily: 'Metropolis',
};

export const subtitleStyle = {
  fontFamily: 'QuickSand',
};

export const titleHighlightedStyle = {
  color: colors.GREEN,
};

export const exportIcon = {
  width: '25%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export default {
  mainContainer,
  containerButton,
  loadingButtonStyle,
  loadingButtonDisabledStyle,
  titleStyle,
  subtitleStyle,
  titleHighlightedStyle,
  exportIcon,
};
